export default __webpack_public_path__ + "static/media/arrow_left_large.704cf566.svg";